(function($) {
    $.fn.suggestText = function(options) {
        return this.each(function() {
            var $input = $(this);
            var suggestTextOptions = $input.data('suggestTextOptions');
            var $optionHtml = $('<ul>');
            $optionHtml.addClass('suggestTextDropdown');
            $.each(suggestTextOptions, function(label, value) {
                var $option = $('<li class="textSuggestions" value="'+value+'">' + label + '</li>');
                $optionHtml.append($option);
            });
            //create the dropdown
            $input.on('focus', function(e) {
                var offset = $input.offset();
                $optionHtml.css({
                    top: offset.top + $input.outerHeight(),
                    left: offset.left,
                    width: $input.outerWidth()
                });
                $('body').append($optionHtml);
                // append input value on clicking option
                $optionHtml.children().on('mousedown', function() {
                    var cursorPos = $input[0].selectionStart;
                    // if maxlength is set, do not append input
                    // maxLength is -1 when not set
                    if ($input.val().length === parseInt($input[0].maxLength)) {
                        return;
                    }
                    $input.val($input.val().substring(0, cursorPos) + $(this).attr('value') + $input.val().substring(cursorPos));
                });
            }).on('blur', function() {
                setTimeout(function() {
                    $optionHtml.remove();
                }, 100);
            });
            //attach the insertion event
        });
    };
    $(function() {
        $('.suggestText').suggestText();
    });
})(jQuery);